import { NavLink } from 'react-router-dom';
import styled from 'styled-components';
import {
  breakpoints,
  borderRadius,
  boxShadow,
  colors,
  verticalGutter
} from '../../styles';

/**
 * @style <li> level style
 */
export const StyledMenuList = styled.li`
  position: relative;
  a {
    text-decoration: none !important;
  }

  ul {
    list-style: none;
    @media screen and (max-width: ${breakpoints.wideMobile}) {
      padding-left: 0;
    }
  }

  .isvg svg {
    display: inline-block;
    vertical-align: middle;
  }

  /* namespace'd  */
  .menuitem {
    /* root icon */
    &__icon {
      display: flex;
      align-self: center;
      min-width: 2rem;
      margin-right: ${verticalGutter / 3}rem;
      path {
        fill: ${({ active, disabled }) =>
          disabled ? colors.grey : active ? colors.primary : colors.textColor};
      }
    }

    &__external {
      margin-left: ${verticalGutter / 2}rem;
      pointer-events: none;
    }

    &__title {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
  }
`;

/**
 * @style <a> level style
 */
export const StyledMenuLink = styled(NavLink)`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: ${verticalGutter / 2}rem ${verticalGutter}rem;

  /* sub menu arrow */
  > i.icon.angle {
    position: absolute;
    right: 0;
  }

  /* namespace'd  */
  &.menuitem {
    &__link {
      cursor: pointer;

      &:not(.menuitem__link--root) {
        border-bottom: 2px solid ${colors.lighterGrey};
        ~ ul a {
          border-bottom-width: 1px;
        }
      }

      &--root {
        background: linear-gradient(
          180deg,
          ${colors.borderGrey} 0%,
          rgba(231, 231, 231, 0.4) 0%,
          rgba(242, 242, 242, 0) 100%
        );
        color: ${colors.textColor};
        .menuitem__external {
          path,
          polygon {
            fill: ${colors.textColor};
          }
        }
      }

      &:hover,
      &--active {
        color: ${colors.primary};
        .icon.angle:before {
          border-color: ${colors.primary};
        }
        path,
        polygon {
          fill: ${colors.primary};
        }
      }

      &--disabled {
        cursor: default;
        pointer-events: none;
        color: ${colors.grey};
        path,
        polygon {
          fill: ${colors.grey} !important;
        }
      }
    }
  }
`;

/**
 * @style desktop flyout sub menu styles
 */
export const StyledSubmenu = styled.div`
  position: absolute;
  top: 0;
  left: 100%;
  box-shadow: ${boxShadow.menu};

  header {
    background: ${colors.lighterGrey};
    height: 2.75rem;
    width: 100%;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    .icon.close {
      margin: 0 !important;
    }
  }

  > ul {
    list-style: none;
    padding: ${verticalGutter / 2}rem;
    background: ${colors.borderGrey};
    max-height: 600px;

    > li {
      background: ${colors.white};
      box-shadow: ${boxShadow.small};
      border-radius: ${borderRadius.medium};
      margin: 2px 0;
      padding: ${verticalGutter / 4}rem ${verticalGutter / 2}rem;
      font-weight: bold;
      a {
        white-space: nowrap;
        svg {
          margin-left: 8px;
        }
      }
      &:hover {
        background: rgba(255, 255, 255, 0.75);
      }
      > :first-child {
        display: flex;
        /* justify-content: space-between; */
        padding: ${verticalGutter / 4}rem ${verticalGutter / 2}rem;
        margin: ${verticalGutter / -4}rem ${verticalGutter / -2}rem;
      }
    }
  }
`;
